<template>
	<div class="app-shell">
		<app-header v-if="!isLoginRoute" />
		<main class="app-content">
			<router-view />
			<app-notification-container />
		</main>
	</div>
</template>

<script setup lang="ts">
import {
	computed,
	onMounted,
	watch
} from "vue";
import { useRoute } from "vue-router";
import { useSignalR } from "@/composables/useSignalR";
import { rootStore } from "@/store/index";
import AppNotificationContainer from "@/components/ui-kit/notifications/AppNotificationContainer.vue";
import AppHeader from "@/components/layout/AppHeader/AppHeader.vue";

const route = useRoute()
const root = rootStore()
const { init: initSignalR } = useSignalR()

const isLoginRoute = computed(() => route.path === '/login')

let signalRStarted = false
const startSignalROnce = () => {
	if (!signalRStarted && root.jwtToken) {
		signalRStarted = true
		initSignalR()
	}
}
onMounted(() => startSignalROnce())
watch(() => root.jwtToken, () => startSignalROnce())
</script>

<style scoped>
.app-shell {
	display: flex;
	flex-direction: column;
	height: 100vh;
	width: 100vw;
	overflow: hidden;
}

.app-content {
	flex: 1;
	min-height: 0;
	background: #F2F2F2;
	overflow: hidden;
	position: relative;
}
</style>
